var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7 11H17V13H7V11ZM4 7H20V9H4V7ZM10 15H14V17H10V15Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }